import { NavBar } from '@/components/organisms/NavBar';
import type { ReactNode } from 'react';

type PrivateLayoutProps = {
	children: ReactNode;
};

export const PrivateLayout = ({ children }: PrivateLayoutProps) => {
	return (
		<div className="flex h-screen w-screen flex-col bg-dark lg:flex-row">
			<NavBar />

			<main className="relative flex h-full w-full flex-grow overflow-hidden ease-in-out">
				{children}
			</main>
		</div>
	);
};
